import { WorkflowCreateMethodTypes } from "@enums/workflow-create-method-types";
import { SelectOption } from "@idw-types/common";

export const WORKFLOW_CREATE_METHOD_OPTIONS: Array<SelectOption<WorkflowCreateMethodTypes>> = [
    { 
        label: "Create a new Workflow using a template",
        value: WorkflowCreateMethodTypes.USE_TEMPLATE
    },
    {
        label: "Create a new Workflow from an import file",
        value: WorkflowCreateMethodTypes.USE_IMPORT
    },
    {
        label: "Create a copy of an existing Workflow",
        value: WorkflowCreateMethodTypes.USE_COPY
    }
];